declare namespace $ {

	type $mol_paragraph__title_demo_app_1 = $mol_type_enforce<
		ReturnType< $demo_app['greeting'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_demo_app_2 = $mol_type_enforce<
		ReturnType< $demo_app['pinned_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_demo_app_3 = $mol_type_enforce<
		ReturnType< $demo_app['static_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_demo_app_4 = $mol_type_enforce<
		ReturnType< $demo_app['note_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $demo_note_card__note_ref_demo_app_5 = $mol_type_enforce<
		ReturnType< $demo_app['card_ref'] >
		,
		ReturnType< $demo_note_card['note_ref'] >
	>
	export class $demo_app extends $mol_page {
		greeting( ): string
		Greeting( ): $mol_paragraph
		pinned_title( ): string
		Pinned( ): $mol_paragraph
		static_title( ): string
		Static_panel( ): $mol_paragraph
		Live( ): $demo_note_live
		note_rows( ): readonly(any)[]
		Note_list( ): $mol_list
		card_ref( id: any): any
		title( ): string
		body( ): readonly(any)[]
		Note_card( id: any): $demo_note_card
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map